import onFolderForestNodeSelected from "./onFolderForestNodeSelected";
import commandBarAction from "owa-group-header-store/lib/actions/commandBarAction";
import NavigationButton from "owa-group-header-store/lib/store/schema/NavigationButton";
import { lazyOnSelectedPersonaNodeChanged } from "owa-mail-favorites-store";
import setGroupLastVisitedTime from "owa-groups-left-nav-actions/lib/utils/setGroupLastVisitedTime";
import { getGroupIdFromTableQuery } from "owa-group-utils";
import { getSelectedTableView } from "owa-mail-list-store";
import type { ActionSource } from "owa-mail-store";
import { mutatorAction } from "satcheljs";
import { getStore } from "owa-mail-folder-forest-store";
import type { FavoritePersonaNode, FolderForestNode, GroupForestNode } from "owa-favorites-types";
import { type FolderForestNodeType } from "owa-favorites-types";
import type { SessionData } from "owa-service/lib/types/SessionData";

/**
 * Set the selected node in the folder forest
 * @param node node to be selected
 * @param actionSource action that initiated the switch folder action
 * @return a promise that resolves when the select node has completed
 */
export default function selectNodeInFolderForest(node: FolderForestNode, actionSource?: ActionSource, sessionData?: SessionData, isSearchFolder?: boolean): Promise<void> {
    const storeSelectedNode = getStore().selectedNode;
    const selectedNodeType = storeSelectedNode.type;
    if (selectedNodeType === 1) {
        lazyOnSelectedPersonaNodeChanged.importAndExecute(storeSelectedNode as FavoritePersonaNode);
    }
    
    if (selectedNodeType === 2) {
        // If switching from Group to another node, set the time last visited for the group.
        // This will only be needed while Groups supports both seen/unseen and read/unread on
        // different clients. TO-DO 115698: Remove this when legacy clients are no longer using
        // seen/unseen and requiring lastVisitedTime.
        // Skip it in case of delete groups as this will trigger a mailbox association notification with
        // IsMember true and bring the group back to the left nav.
        if (actionSource != "DeleteGroup") {
            const groupNode: GroupForestNode = node as GroupForestNode;
            const tableView = getSelectedTableView();
            tableView &&
                setGroupLastVisitedTime(groupNode.mailboxInfo, 
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2345 (48,21): Argument of type 'string | null' is not assignable to parameter of type 'string'.
                // @ts-expect-error
                getGroupIdFromTableQuery(tableView.tableQuery));
        }
        
        // If switching from Group to Folder or other types,
        // reset the Group Header CommandBar state so it shows Conversations tab
        if (node.type !== 2) {
            commandBarAction(NavigationButton.Email);
        }
    }
    
    const selectedNode = { ...node };
    
    // Set the selected node properties in folder forest store
    setSelectedFolderNodeMutator(selectedNode);
    
    return onFolderForestNodeSelected(selectedNode, actionSource, sessionData, isSearchFolder);
}

const setSelectedFolderNodeMutator = mutatorAction("setSelectedFolderNode", (node: FolderForestNode) => {
    getStore().selectedNode = node;
});
